/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useMemo, useState } from 'react';
import useIsPrinting from '../../utilities/PrintUtilities';

/**
 * Expandable string list component. It expects prop.value to be an array of strings, and optionally takes a
 * maxLines property to override the default number of strings shown.
 * @param props
 * @returns {*}
 * @constructor
 */
export default function PropertiesStringList(props) {
    const { value, maxLines = 3 } = props;
    const [expanded, setExpanded] = useState(false);
    const isPrinting = useIsPrinting();

    return useMemo(() => {
        // Guard against undefined or null values
        if (!value || !Array.isArray(value) || value.length === 0) {
            return null;
        }

        return (
            <div>
                {value.slice(0, expanded || isPrinting ? value.length : maxLines).map((item, index) => (
                    <div key={`${index}`}>{item}</div>
                ))}
                {maxLines < value.length && !expanded && !isPrinting && (
                    <a href="#" onClick={() => setExpanded(true)}>
                        {`Show ${value.length - maxLines} more...`}
                    </a>
                )}
            </div>
        );
    }, [expanded, maxLines, value, isPrinting]);
}
